export const formMutationDto = (data: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form_data: Record<string, any> | null;
  stepper: { step: number; innerStep: { [p: number]: number } };
}) => {
  return {
    form_data: {
      data: data.form_data,
      stepper: data.stepper,
    },
  };
};
